/**
 * Agent 14-day trial copy.
 *
 * Billing is unchanged. create-checkout-session.js collects a card
 * (payment_method_types: ['card'], and it does not set
 * payment_method_collection: 'if_required') and sets trial_period_days: 14.
 * There is no setup fee. The first subscription invoice is at the end of
 * the trial. Canceling that trialing subscription in the Stripe Customer
 * Portal before day 14 does not create a charge.
 */

const TRIAL_CARD_REQUIRED =
  "14-day free trial • Card required, cancel anytime before day 14 and you won't be charged";

const TRIAL_SHORT = '14-day free trial • Card required';

const TRIAL_CANCEL_LINE =
  "Card required • Cancel before day 14 and you won't be charged";

function trialPriceLine(monthlyLabel) {
  return `Card required. ${monthlyLabel} after day 14. Cancel before then and you won't be charged.`;
}

function teamPlansFromLabel(plans) {
  const prices = (Array.isArray(plans) ? plans : [])
    .map((plan) => Number(plan && plan.price))
    .filter((price) => Number.isFinite(price));
  if (!prices.length) return 'Team plans';
  const from = Math.min.apply(null, prices);
  return `Team plans from $${from}/month`;
}

function startingTrialMessage(planLabel) {
  return `You've selected the ${planLabel} plan.\n\n✓ Card required at checkout\n✓ 14-day free trial\n✓ Cancel before day 14 and you won't be charged\n✓ Full refund of the first paid charge if you ask within 7 days (this also cancels the account). No prorated refunds after that.\n\nRedirecting to secure checkout...`;
}

const TRIAL_CONFIRM_BULLETS =
  "• 14-day free trial\n• Card required\n• Cancel before day 14 and you won't be charged\n• Full refund of the first paid charge if you ask within 7 days (this also cancels the account). No prorated refunds after that.";

export {
  TRIAL_CARD_REQUIRED,
  TRIAL_SHORT,
  TRIAL_CANCEL_LINE,
  TRIAL_CONFIRM_BULLETS,
  trialPriceLine,
  teamPlansFromLabel,
  startingTrialMessage,
};
